// extracted by mini-css-extract-plugin
export var root = "Footer-module--root--3-fYg";
export var container = "Footer-module--container--2LcUy";
export var content = "Footer-module--content--1zFLj";
export var creator = "Footer-module--creator--3cOS5";
export var creatorIcon = "Footer-module--creatorIcon--2Yoby";
export var light = "Footer-module--light--2SHU5";
export var privacy = "Footer-module--privacy--3W7p8";
export var dark = "Footer-module--dark--3EdZ9";